import React from 'react';
import {
  usePagination,
  UsePaginationProps,
} from 'react-instantsearch';

interface CustomPaginationProps {
    classNames: {
        root?: string;
        list?: string;
        item?: string;
        selectedItem?: string;
    };
}
type Props = CustomPaginationProps & UsePaginationProps;
export default function CustomPagination(props: Props) {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL,
  } = usePagination(props);
  const firstPageIndex = 0;
  const previousPageIndex = currentRefinement - 1;
  const nextPageIndex = currentRefinement + 1;
  const lastPageIndex = nbPages - 1;
  if (nbPages <= 1) {
    return <></>
  }
  return (
    <div className={`ais-Pagination ${props.classNames?.root}`}>
        <ul className={`ais-Pagination-list ${props.classNames?.list}`}>
        {(((currentRefinement+1)-(props.padding || 3)) > 1) && 
        <>
            <PaginationItem
                isDisabled={isFirstPage}
                href={createURL(firstPageIndex)}
                onClick={() => refine(firstPageIndex)}
                className={`ais-Pagination-item ${props.classNames?.item}`}
            >
                {1}
            </PaginationItem>
            {(((currentRefinement+1)-(props.padding || 3)) > 2) && 
                <li className={`ais-Pagination-item ${props.classNames?.item}`}>...</li>
            }
        </>}
        {pages.map((page) => {
            const label = page + 1;
            
            return (
            <PaginationItem
                key={page}
                isDisabled={false}
                aria-label={`Page ${label}`}
                href={createURL(page)}
                onClick={() => refine(page)}
                className={`ais-Pagination-item ${props.classNames?.item} ${currentRefinement === page ? props.classNames?.selectedItem : ''}`}
            >
                {label}
            </PaginationItem>
            );
        })}
         {(((currentRefinement+1)+(props.padding || 3)) < nbPages) &&
         <>
            {(((currentRefinement+1)+(props.padding || 3)) < nbPages-1) &&
                <li className={`ais-Pagination-item ${props.classNames?.item}`}>...</li>
            }
            <PaginationItem
                isDisabled={isLastPage}
                href={createURL(lastPageIndex)}
                onClick={() => refine(lastPageIndex)}
                className={`ais-Pagination-item ${props.classNames?.item}`}
            >
                {nbPages}
            </PaginationItem>
        </>}
        </ul>
    </div>
  );
}

type PaginationItemProps = Omit<React.ComponentProps<'a'>, 'onClick'> & {
  onClick: NonNullable<React.ComponentProps<'a'>['onClick']>;
  isDisabled: boolean;
};

function PaginationItem({
  isDisabled,
  href,
  onClick,
  ...props
}: PaginationItemProps) {
  if (isDisabled) {
    return (
      <li>
        <span {...props} />
      </li>
    );
  }

  return (
    <li>
      <a
        href={href}
        onClick={(event) => {
          if (isModifierClick(event)) {
            return;
          }
          event.preventDefault();
          onClick(event);
        }}
        {...props}
      >{props.children}</a>
    </li>
  );
}

function isModifierClick(event: React.MouseEvent) {
  const isMiddleClick = event.button === 1;

  return Boolean(
    isMiddleClick ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey
  );
}